module.exports = __webpack_public_path__ + "static/media/arrow-up-blue.9c99763d.svg";